var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRubleSign = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M64 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32zm64 64h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H128z",
  style: {
    opacity: 0.4
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M64 64c0-17.7 14.3-32 32-32h144c79.5 0 144 64.5 144 144s-64.5 144-144 144H128v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32zm64 192h112c44.2 0 80-35.8 80-80s-35.8-80-80-80H128z",
  className: "ruble-sign_svg__fa-primary"
})));
export default SvgRubleSign;